/**
 * Application environment detection.
 *
 * Hostname-based so individual deploys don't need their own env var:
 *   localhost   -> 'local'
 *   *.dev.*     -> 'dev'
 *   *.staging.* -> 'staging'
 *   *.pre-prod.* -> 'pre-prod'
 *   otherwise   -> 'production'
 *
 * This mirrors the gate logic already used by PostHog in ./posthog.ts and
 * is the single source of truth for environment-conditional behaviour
 * (Featurebase widget, Marker.io, PostHog opt-in, etc.).
 */
export type AppEnv = 'local' | 'dev' | 'staging' | 'pre-prod' | 'production'

export function getAppEnv(): AppEnv {
  const host = window.location.hostname

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'local'
  }
  if (host.includes('.dev.')) {
    return 'dev'
  }
  if (host.includes('.staging.')) {
    return 'staging'
  }
  if (
    host.startsWith('pre-prod.') ||
    host.startsWith('preprod.') ||
    host.startsWith('pre-production.') ||
    host.includes('.pre-prod.') ||
    host.includes('.preprod.') ||
    host.includes('.pre-production.')
  ) {
    return 'pre-prod'
  }
  return 'production'
}
